const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:5000/' : 'https://api-m3guo.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:9633/' : 'https://www.m3guo.com/activity/202207/v1348b20/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'm.html';

const activityTime = '2022.06.03-2022.07.03';

const startTime = 1656640800000;

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const tipsImg = ['D774', 'KB65', 'KR48', 'KY25', 'KY26', 'LH83',]

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const wx_share_text = {
  title: '华山论剑即将开启', // 分享标题
  desc: '新英雄梦刘禅即将上线', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202207/version/sns.jpg', // 分享图标   
}

const issn = '220606';

const ajax_url_map = {
  login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  free : host + 'api/Login/KouDai',
  logininfo : host + 'api/user/getLoginInfo',
  userinfo : host + 'api/user/getUserInfo',
  queryplayer : host + 'api/user/GetNickName',
  bind : host + 'api/user/bind',
  task : host + 'api/userTask/taskList?gid=1',
  story : host + 'api/userTask/taskList?gid=2',
  passport : host + 'api/userTask/taskList?gid=3',
  shop_list : host + 'api/Gift/List?part=2',
  mplat : host + 'api/login/mplat',//梦平台免登录
  gift : host + 'api/Gift/RwTaskType',
  ticket : host + 'api/gift/buy',
  task_apply : host + 'api/UserTask/CompletedScore',
  share_apply : host + 'api/share/getInviteCode',
  history : host + 'api/Order/GetOrderList?type=2',
  share : host + 'api/gift/reward',
  riddle : host + 'api/gift/riddle',//黑手
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}


const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]


export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    activityTime,
    startTime,
    tipsImg,
    wx_share_text,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js